import styled from "styled-components";

const StyledTd = styled.td`
  color: white !important;
  font-weight: bold;
  font-size: 1rem;
`;

const StyledTr = styled.tr`
  margin-bottom: 0.5rem;
`;

const EmptyMessageTd = styled.td`
  text-align: center;
  padding: 1rem;
  color: #878a99;
`;

function ApsInformation({ apsData = [], workTime, totalQty }) {
  return (
    <tbody>
      {apsData.length ? (
        <>
          <StyledTr>
            <td>가동시간</td>
            <StyledTd>
              {workTime.map((time, index) => (
                <span key={index}>
                  {index > 0 && <br />}
                  {time}
                </span>
              ))}
            </StyledTd>
          </StyledTr>
          <StyledTr>
            <td>생산수량</td>
            <StyledTd>{totalQty}</StyledTd>
          </StyledTr>
          {/* <StyledTr>
            <td>진행률</td>
            <td>{progressRate}%</td>
          </StyledTr> */}
          <StyledTr>
            <td>전일 실적</td>
            <StyledTd>100%</StyledTd>
          </StyledTr>
        </>
      ) : (
        <tr>
          <EmptyMessageTd colSpan="2">표시할 데이터가 없습니다.</EmptyMessageTd>
        </tr>
      )}
    </tbody>
  );
}

export default ApsInformation;
